import { render, staticRenderFns } from "./PointDefinitionDialog.vue?vue&type=template&id=9bf43e56"
import script from "./PointDefinitionDialog.vue?vue&type=script&lang=ts"
export * from "./PointDefinitionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports